module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "ch01"
    }
  }), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("CHAPTER ONE")])])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('h2', {
    staticClass: "h2title"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Foundering Father")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("If an eighteen-year-old George Washington had gotten his way, there would have been no Robert E. Lee. Lee would never have married the daughter of Washington’s adopted son, never have stared up at Washington’s marble statue, and never have gone to war against Washington’s Union. These events, of course, all lay in the unknowable future for Washington circa 1750. All he knew then was that he loved a girl who did not love him in return. He could not have imagined who her grandson might one day be.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("History shines little light on the infatuation that stirred in Washington’s adolescent mind. Only fragments of letters illuminate the tale. Apparently, even the mere sight of other women inflamed the crush. Once, while in the company of ")]), _c('a', {
    attrs: {
      "id": "note37"
    }
  }, [_vm._v("“a very agreeable young lady,” Washington complained that her appearance revived his “former passion” for the “Low Land Beauty.” How he longed, he said, to bury that “troublesome passion in the grave of oblivion.” Legend holds that this lowland beauty was a ")]), _c('a', {
    attrs: {
      "id": "note38"
    }
  }, [_vm._v("blue-eyed blonde named Lucy Grymes. Though not all historians agree, Washington’s moniker fits Lucy’s description. She hailed from Virginia’s lowlands, and her many suitors testified to her beauty. The evidence later persuaded her most famous grandson, Robert E. Lee. ")]), _c('a', {
    attrs: {
      "id": "note39"
    }
  }, [_vm._v("“I believe,” he wrote, “there are grounds for the belief that Genl Washington in early life was pleased with the beauty.” Whatever Washington’s true interest, the match was not to be. In 1753, Lucy ")]), _c('a', {
    attrs: {
      "id": "note40"
    }
  }, [_vm._v("married a lawyer named Henry Lee II.")])]), _c('a', {
    attrs: {
      "id": "note40"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "note40"
    }
  }), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("That a country lawyer could snag the belle of the ball over the future Father of His Country might seem surprising until one considers that Washington at the time could not even present himself as master of his own home. In fact, a year earlier, the Lee family had come into possession of something else Washington coveted: the Potomac property known as Mount Vernon. When owner Lawrence Washington died in 1752, he left the estate first to his widow, Anne, and then upon her death to his favorite half brother, George Washington. Anne, as it turned out, chose not to dally at Mount Vernon. Within a year, she married one of Henry Lee II’s cousins, George Lee. Choosing to live elsewhere, the new couple ")]), _c('a', {
    attrs: {
      "id": "note41"
    }
  }, [_vm._v("leased Mount Vernon to the man they knew would inherit it anyway. For more than six years, George Washington lived as a tenant of the Lee family. Not until Anne Lee died in 1761 did Washington take full ownership of Mount Vernon.")])]), _c('a', {
    attrs: {
      "id": "note41"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "note41"
    }
  }, [_vm._v("While Washington’s greatness still lay in the future, the Lees had already established themselves as one of Virginia’s finest families. Henry Lee II’s great-grandfather Richard “The Emigrant” had arrived in Jamestown around 1640 as a clerk and died a quarter century later as a veritable baron, owning numerous African slaves and ")]), _c('a', {
    attrs: {
      "id": "note42"
    }
  }, [_vm._v("fifteen thousand acres of land, much of it on the Tidewater tract called the Northern Neck between the Potomac and Rappahannock Rivers. Richard Lee had gambled by moving up the Chesapeake Bay from the colony’s first and more fashionable settlements around Jamestown to this still sparsely populated northern frontier. As late as 1653, the Potomac ")]), _c('a', {
    attrs: {
      "id": "note43"
    }
  }, [_vm._v("backlands contained only about a thousand colonists, but soon great houses would rise across the region.")])]), _c('a', {
    attrs: {
      "id": "note43"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "note43"
    }
  }, [_vm._v("On the fossil-rich white cliffs overlooking the river in Westmoreland County, Henry Lee II’s uncle ")]), _c('a', {
    attrs: {
      "id": "note44"
    }
  }, [_vm._v("Thomas Lee built an imposing brick mansion called Stratford Hall. The commanding spot befitted the fortune he had made as a royal naval inspector on the river and as a land agent in the surrounding regions. As Thomas Lee explored the Potomac, he became convinced that it represented a water highway to the vast lands beyond the Appalachian Mountains. In 1744, he negotiated an Indian treaty opening the Ohio country for white settlement ")]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("and then united fellow land speculators in a venture called the Ohio Company. When Thomas Lee died in 1750, Lawrence Washington took over as president of the company. For all that he had accomplished during his life, Thomas Lee achieved his greatest distinction posthumously: two of his sons, Richard Henry Lee and Francis Lightfoot Lee, would sign the Declaration of Independence.")])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("As Thomas Lee’s nephew, Henry Lee II would have disappeared under the shadow of his celebrated cousins if not for his marriage to beautiful Lucy. The couple settled not far downriver from Mount Vernon. In 1756, they named their first son Henry Lee III. A half century later, this boy, known as Harry, would father the most famous rebel general of the Civil War. But first he fought his own revolution. He would owe his success to a surprising benefactor: his father’s old romantic rival, George Washington.")]), _vm._v(" "), _c('p', {
    staticClass: "secbreak"
  }, [_vm._v("*  *  *")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("It was said that Harry Lee came “out of his ")]), _c('a', {
    attrs: {
      "id": "note45"
    }
  }, [_vm._v("mother’s womb a soldier.” Perhaps part of Washington still wished he had placed him there. More likely, Washington simply possessed avuncular feelings for the young neighbor who grew up calling Mount Vernon’s mistress ")]), _c('a', {
    attrs: {
      "id": "note46"
    }
  }, [_vm._v("“Aunt Martha.” Washington had married the rich widow Martha Dandridge Custis a few years after Harry’s birth. Though Martha brought two children from her previous marriage to Mount Vernon, she never gave the Father of His Country a biological child of his own, a fact Washington would later use to ")]), _c('a', {
    attrs: {
      "id": "note47"
    }
  }, [_vm._v("quiet any talk of an American monarchy. The man who would not be king had no lineal heirs.")])]), _c('a', {
    attrs: {
      "id": "note47"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "note47"
    }
  }, [_vm._v("To fill the void, Washington seemed always on the lookout for the son he would never have. While commanding the Continental Army, he forged closer bonds with young officers than with his fellow generals. His ")]), _c('a', {
    attrs: {
      "id": "note48"
    }
  }, [_vm._v("military family included the brilliant Caribbean immigrant Alexander Hamilton, the principled South Carolinian John Laurens, and the idealistic Marquis de Lafayette of France. None of these aides had even been born when, in 1754, Washington fought the first battles of the French and Indian War while commanding militia loyal to the ")]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("British crown. But what the aides lacked in experience, they more than compensated for with vigor and intelligence. Washington especially prized their literary talents, which he needed to avoid drowning in the never-ending stream of correspondence that flowed into his camp.")])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("Harry Lee fit the mold of a Washington protégé perfectly. As a student at Princeton (then the College of New Jersey), he earned accolades for his readings and literary ")]), _c('a', {
    attrs: {
      "id": "note49"
    }
  }, [_vm._v("translations. A family friend predicted he “will be one of the ")]), _c('a', {
    attrs: {
      "id": "note50"
    }
  }, [_vm._v("first fellows in this country.” Graduating in 1773, he ")]), _c('a', {
    attrs: {
      "id": "note51"
    }
  }, [_vm._v("shelved plans to study law in London as the chasm between the mother country and the colonies widened. Soon from Williamsburg and Philadelphia came reports of his kinsmen agitating for independence. On June 1, 1776, at the Second Continental Congress, Richard Henry Lee proposed before anyone else, ")]), _c('a', {
    attrs: {
      "id": "note52"
    }
  }, [_vm._v("“That these United Colonies are, and of a right ought to be, free and independent states.” Leaping to second the motion, Massachusetts delegate John Adams later saluted the Lees as a ")]), _c('a', {
    attrs: {
      "id": "note53"
    }
  }, [_vm._v("“band of brothers . . . in the defence of their country.”")])]), _c('a', {
    attrs: {
      "id": "note53"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "note53"
    }
  }, [_vm._v("As these events transpired, Harry Lee traded his dream of a degree in the law for ")]), _c('a', {
    attrs: {
      "id": "note54"
    }
  }, [_vm._v("a commission as a captain in the dragoons. Swift and agile, ")]), _c('a', {
    attrs: {
      "id": "note55"
    }
  }, [_vm._v("these horsemen could gather forage, conduct reconnaissance, and carry out raids where infantry dared not go. Harry Lee made the transition from manor life to camp life seamlessly. By the fall of 1777, his signature had emerged as a familiar line at the bottom of intelligence reports addressed to Washington. He indulged the general’s taste for tales from deserters and ")]), _c('a', {
    attrs: {
      "id": "note56"
    }
  }, [_vm._v("double agents. That winter, during one of his expeditions, a large British force surprised and surrounded him at the Spread Eagle Tavern near Valley Forge. With only a small force, Harry could not even guard all the tavern’s windows. ")]), _c('a', {
    attrs: {
      "id": "note57"
    }
  }, [_vm._v("“The contest was very warm,” he reported. “The British dragoons trusting to their vast superiority in number, attempted to force their way into the house.” Trickery offered the sole hope. ")]), _c('a', {
    attrs: {
      "id": "note58"
    }
  }, [_vm._v("“Fire away, men,” Harry blustered. “Here comes our infantry; we will have them all.” Although he knew no reinforcements were on the way, he also knew his enemies could not be so sure. Taking no risk, the British retreated. Outgunned but not outsmarted, Harry Lee had prevailed.")])]), _c('a', {
    attrs: {
      "id": "note58"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "note58"
    }
  }), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("Washington sent his personal congratulations. The triumph, small as it was, deepened his respect for the young Lee. ")]), _c('a', {
    attrs: {
      "id": "note59"
    }
  }, [_vm._v("“I needed no fresh proof of your merit,” he wrote. “I waited only for the proper time and season to shew it—these I hope are not far off.” As promised, the time and season soon arrived. In March, Harry Lee received an invitation to join Washington’s military family. The offer was tempting for an ambitious twenty-two-year-old. Proximity to power meant power itself. As someone intent on martial fame, however, Harry could not stomach switching from a field officer engaged in battle to a staff officer engaged in correspondence. ")]), _c('a', {
    attrs: {
      "id": "note60"
    }
  }, [_vm._v("“To have possessed a post about your Excellency’s person is certainly the first recommendation I can bear to posterity,” he acknowledged in an artful yet awkward response declining the offer. A few days later, still determined to better employ the young Lee’s ")]), _c('a', {
    attrs: {
      "id": "note61"
    }
  }, [_vm._v("“exemplary zeal, prudence and bravery,” Washington settled on a more suitable promotion. He recommended—and Congress approved—making Harry Lee a major in “command of two troops of Horse,” which together would “act as an independent partisan Corps.”")])]), _c('a', {
    attrs: {
      "id": "note61"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "note61"
    }
  }, [_vm._v("The ")]), _c('a', {
    attrs: {
      "id": "note62"
    }
  }, [_vm._v("hundred horsemen in the new corps would operate outside the normal chain of command. The arrangement afforded Harry Lee an aura of autonomy that more experienced officers could only envy, and envy him they did. Rumors spread that the young Virginian owed his success more to the blood he shared with members of Congress than to the blood he risked on the battlefield. As complaints trickled into headquarters, Washington worried that others were ")]), _c('a', {
    attrs: {
      "id": "note63"
    }
  }, [_vm._v("“extremely jealous of the superior advantages and priviledges which Major Lee has somehow or other obtained.” For Harry, there was no mystery. It was a matter of merit. As Washington had told Congress, ")]), _c('a', {
    attrs: {
      "id": "note64"
    }
  }, [_vm._v("“Capt. Lees genius peculiarly adapts him to a command of this nature.”")])]), _c('a', {
    attrs: {
      "id": "note64"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "note64"
    }
  }, [_vm._v("Peculiar, indeed. Harry Lee possessed a mix of qualities not usually found in one person. Though tanned from his time in the field, his skin was ")]), _c('a', {
    attrs: {
      "id": "note65"
    }
  }, [_vm._v("“as fair as a lily.” His blue eyes scanned the battlefield beneath arched brows. Though not large in stature, he commanded respect in the saddle. One observer fancied him a ")]), _c('a', {
    attrs: {
      "id": "note66"
    }
  }, [_vm._v("“little hero.” Though a meticulous planner, he was quick in action. Though a stern disciplinarian, he ")]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("showed devotion to his men. In their eyes and to the world, he became known as “Light-Horse Harry” Lee.")])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("In 1779, the corps conducted a surprise attack against the British outpost at Paulus Hook, New Jersey. Approaching under the cover of night, Harry Lee threatened to execute any of his soldiers who ")]), _c('a', {
    attrs: {
      "id": "note67"
    }
  }, [_vm._v("“may violate in the slightest degree the silence he has ordered to be observed.” The soldiers did not dare defy him. Just recently he had sentenced a deserter among them to be decapitated despite Washington’s decrying the ")]), _c('a', {
    attrs: {
      "id": "note68"
    }
  }, [_vm._v("“inhumanity.” Now, as the men charged through the final defensive ditch, discipline held. With their bayonets fixed, the attackers achieved complete surprise. The raid yielded more than ")]), _c('a', {
    attrs: {
      "id": "note69"
    }
  }, [_vm._v("150 prisoners. Washington proclaimed it a ")]), _c('a', {
    attrs: {
      "id": "note70"
    }
  }, [_vm._v("“brilliant transaction.” Not all of Harry Lee’s fellow officers were so pleased. Some accused him of breaking the chain of command. A court-martial ensued. ")]), _c('a', {
    attrs: {
      "id": "note71"
    }
  }, [_vm._v("Enraged, the young officer could see no middle course between accepting dishonor and resigning. That he would even consider such extremes revealed a rashness that worried Washington. ")]), _c('a', {
    attrs: {
      "id": "note72"
    }
  }, [_vm._v("“I should be sorry you would suffer your sensibility to betray you into an error which on reflexion you would condemn,” the general wrote. In the end, Harry received vindication three times over. The court-martial cleared him of the charges, Congress struck a gold medal in his honor, and Washington gave him permission to label their letters ")]), _c('a', {
    attrs: {
      "id": "note73"
    }
  }, [_vm._v("“private” so that other officers would not read their correspondence. The two had sealed a bond that would last for life.")])]), _c('a', {
    attrs: {
      "id": "note73"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "note73"
    }
  }, [_vm._v("Toward the end of the war, ")]), _c('a', {
    attrs: {
      "id": "note74"
    }
  }, [_vm._v("Washington sent “Lee’s Legion,” which now included infantry, to the conflict’s southern theater, where the British had tightened their grip. Harry persuaded the American theater commander, Major General Nathanael Greene, to lead an offensive into South Carolina. It would prove a ")]), _c('a', {
    attrs: {
      "id": "note75"
    }
  }, [_vm._v("turning point. With Greene moving farther south, his British counterpart, General Charles Cornwallis, decided to head north to Virginia. That path would eventually pen the British into a place called Yorktown. There, in October 1781, Harry Lee watched the British surrender to a combined American-French force with Washington at its head. ")]), _c('a', {
    attrs: {
      "id": "note76"
    }
  }, [_vm._v("“The British army,” Harry ")]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("Lee remembered many years later, “marched out of its lines with colors cased, and drums beating. . . . Certainly no spectacle could be more impressive.”")])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("Though another two years would pass before the signing of a peace treaty, Harry Lee chose not to remain in the field with his troops. A few months after Yorktown, he headed home. His youngest son, Robert, would later blame this shameful abdication on ")]), _c('a', {
    attrs: {
      "id": "note77"
    }
  }, [_vm._v("“broken health,” which “depressed his spirits.” Probably the reverse was true. Harry Lee’s problems started in his head and spread from there. While ")]), _c('a', {
    attrs: {
      "id": "note78"
    }
  }, [_vm._v("deflecting General Greene’s praise for his contributions to the overall strategy, he stewed over perceived slights in individual battle reports. More troubling were the old accusations that his success resulted from ")]), _c('a', {
    attrs: {
      "id": "note79"
    }
  }, [_vm._v("family connections instead of from individual merit. By early 1782, Harry Lee could no longer bear, as he put it, ")]), _c('a', {
    attrs: {
      "id": "note80"
    }
  }, [_vm._v("“the indifference with which my efforts to advance the cause of my country is considered by my friends . . . and my consciousness that it is not in my power to efface the disagreeable impression.” Like Washington, Greene feared the young man would make an impetuous decision. ")]), _c('a', {
    attrs: {
      "id": "note81"
    }
  }, [_vm._v("“I believe few officers, either in America or Europe, are held in so high a point of estimation as you are,” Greene wrote. ")]), _c('a', {
    attrs: {
      "id": "note82"
    }
  }, [_vm._v("“Envy is the best evidence in the world of great merit.”")])]), _c('a', {
    attrs: {
      "id": "note82"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "note82"
    }
  }, [_vm._v("With depression clouding his mind, Harry Lee refused to see reason. His self-control disappeared in a storm of self-pity. ")]), _c('a', {
    attrs: {
      "id": "note83"
    }
  }, [_vm._v("“I am candid to acknowledge my imbecility of mind, and hope time and absence may alter my feelings: at present my fervent wish is for the most hidden obscurity,” he wrote in a letter explaining his decision to leave the army. “I wish I could bend my mind to other decisions. I have tried much, but the sores of my wounds are only irritated afresh by such efforts. My poor soldiers are dear to me, most dear. I pray your patronage to them if I must part.” And part he did.")])]), _c('a', {
    attrs: {
      "id": "note83"
    }
  }, [_c('p', {
    staticClass: "secbreak"
  }, [_vm._v("*  *  *")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "note83"
    }
  }, [_vm._v("At twenty-six years old, Harry Lee had fixed a new course that would lead to insolvency and ignominy. The dashing horseman, who had outmaneuvered ")]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("his enemies on the battlefield, became a hopeless speculator, who bet his fortune on land and lost. The officer who had brought discipline to the ranks could apply none to himself. The prodigy, whose success had come so early and easily, degenerated into a pathetic personification of failure. Of all the cruel reversals that visited Harry in this second act, the cruelest was Washington’s unintentional role in the tragedy. The friendship that fueled Harry Lee’s rise during the Revolution now hastened his demise. The more closely he followed Washington, the more he courted misfortune.")])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("As with so much in Harry’s life, the trouble began on the Potomac. There was no greater apostle for the river’s possibilities than George Washington. The river had enchanted Washington since boyhood. At age sixteen, he joined a surveying expedition that tramped over the mountains to the river’s upper stretches. The journey took him over ")]), _c('a', {
    attrs: {
      "id": "note84"
    }
  }, [_vm._v("“the worst road that ever was trod by man or beast” into the dark woods where Indians performed the “war daunce” and “wild turkies” roamed. Washington’s career started here, near where the Potomac begins, and their two paths never diverged. Like Thomas Lee, Washington believed the Potomac, which flows eastward down the Appalachians to the Chesapeake Bay, would serve as an artery for traders and settlers. Rather than divide north and south, the river would connect east and west.")])]), _c('a', {
    attrs: {
      "id": "note84"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "note84"
    }
  }, [_vm._v("Below present-day Washington, DC, the wide river that runs past Mount Vernon’s bluff invites such optimism. But above the capital, this gentle tidal scene meets the stronger rock of the piedmont, a landscape that has ")]), _c('a', {
    attrs: {
      "id": "note85"
    }
  }, [_vm._v("resisted change for millions of years. Across this time warp, the Potomac tumbles forty feet down in just two hundred yards. For the Potomac to connect east and west as Washington envisioned, a canal would have to bypass these rocky rapids known as Great Falls. After the Revolution, Washington was ")]), _c('a', {
    attrs: {
      "id": "note86"
    }
  }, [_vm._v("named president of a company that Maryland and Virginia incorporated to carry out the necessary improvements. He had ")]), _c('a', {
    attrs: {
      "id": "note87"
    }
  }, [_vm._v("“no doubt” that the project would succeed and “bring the Atlantic States & the Western Territory into close connexion, & be productive of very extensive commercial & political consequences.” ")]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("The confidence was contagious. One guest at Mount Vernon remembered ")]), _c('a', {
    attrs: {
      "id": "note88"
    }
  }, [_vm._v("“hearing little else for two days from the persuasive tongue of this great man” and left being “completely infected . . . with the canal mania.” In 1786, Washington informed Harry Lee, ")]), _c('a', {
    attrs: {
      "id": "note89"
    }
  }, [_vm._v("“This business is progressing in a manner that exceeds our most sanguine expectations. Difficulties vanish as we proceed.”")])]), _c('a', {
    attrs: {
      "id": "note89"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "note89"
    }
  }, [_vm._v("Harry Lee bought more than the rhetoric. In 1788, he purchased ")]), _c('a', {
    attrs: {
      "id": "note90"
    }
  }, [_vm._v("five hundred acres of land bordering Great Falls. If the river improvements succeeded—and Washington had said they would—the property’s value would skyrocket. Harry imagined a bustling town with wharves and warehouses ready to serve the endless river traffic sure to follow. ")]), _c('a', {
    attrs: {
      "id": "note91"
    }
  }, [_vm._v("“The advantages,” as he saw them, “infinitely exceed that of any spot of ground in the U. States.” Already sounding like a swindler, he convinced his fellow Princeton graduate James Madison to join the venture. “I consider myself bound to let you have a part of the bargain with me.” If Madison had any doubts about the deal, Washington could put them to rest. ")]), _c('a', {
    attrs: {
      "id": "note92"
    }
  }, [_vm._v("“No man more highly estimates it than General Washington who is one of the best judges of property & is intimately acquainted with the place.”")])]), _c('a', {
    attrs: {
      "id": "note92"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "note92"
    }
  }, [_vm._v("The deal, however, was not as clear-cut as Harry claimed. Instead of dipping his toe, he had jumped into the deep end without a worry as to whether he could stay afloat. The audacity of his purchase surprised even the company’s biggest backer. Washington advised Madison that the land ")]), _c('a', {
    attrs: {
      "id": "note93"
    }
  }, [_vm._v("“opens a field almost too extensive for imagination” but warned that “the profits . . . cannot be immediate.” Not immediate became not ever. Legal disputes, fund-raising deficits, and engineering difficulties ensnared the project. The great metropolis never amounted to more than a ")]), _c('a', {
    attrs: {
      "id": "note94"
    }
  }, [_vm._v("handful of buildings. Before the reality of it all set in, Harry Lee named the town after his wife, Matilda. She was his second cousin, the granddaughter of that early prophet of the Potomac, Thomas Lee. When Harry gained her hand in 1782, he also gained possession of the family’s iconic home at Stratford. It was a sad irony, then, that to pay off the debts for his misguided gambles on the Potomac, Harry Lee began selling off the labors of Thomas Lee’s life. Piece ")]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("by piece, he dismantled Stratford Hall. Matilda’s health disappeared with her estate. As she lay dying in 1790, she attempted to save what was left—just over half of the ")]), _c('a', {
    attrs: {
      "id": "note95"
    }
  }, [_vm._v("6,595 acres—by placing the property in a trust for their oldest son.")])]), _c('a', {
    attrs: {
      "id": "note95"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "note95"
    }
  }, [_vm._v("Washington’s dreams for the Potomac had sucked Harry Lee into a whirlpool of debt. Excuses he had, but he could not talk his way out of the red. That he tried only tarred his reputation more. Even Washington could not escape the swindling. ")]), _c('a', {
    attrs: {
      "id": "note96"
    }
  }, [_vm._v("“Nothing but the untoward & unexpected course of fiscal concerns in this country could have produced delay in my payment of your debt,” Harry assured Washington in early 1798. “I am pained in a great degree to hear of any inconvenience accruing to you.” Nonetheless, a year later the sum remained unpaid. Harry vowed to right his wrongs. ")]), _c('a', {
    attrs: {
      "id": "note97"
    }
  }, [_vm._v("“I shall never recede from my exertions till I do accomplish the end, for no event of my life has given me more anguish,” he promised in May 1799. But time was running short, and when George Washington died later that year, Harry Lee was ")]), _c('a', {
    attrs: {
      "id": "note98"
    }
  }, [_vm._v("still in his debt.")])]), _c('a', {
    attrs: {
      "id": "note98"
    }
  }, [_c('p', {
    staticClass: "secbreak"
  }, [_vm._v("*  *  *")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "note98"
    }
  }, [_vm._v("Harry Lee’s political fortunes turned out much the same. Like many veterans of the Continental Army, he once again marched under Washington’s banner during the fierce political struggles that shaped the early republic. The war veterans had seen firsthand that the survival of liberty depended on the strength of the union between the states. They worried that the Articles of Confederation adopted during the war could not hold. ")]), _c('a', {
    attrs: {
      "id": "note99"
    }
  }, [_vm._v("“The period seems to be fast approaching when the people of these U. States must determine to establish a permanent capable government or submit to the horrors of anarchy and licentiousness,” Harry wrote Washington on September 8, 1786.")])]), _c('a', {
    attrs: {
      "id": "note99"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "note99"
    }
  }, [_vm._v("As Harry penned those words, Washington ")]), _c('a', {
    attrs: {
      "id": "note100"
    }
  }, [_vm._v("pressed for news from a convention on interstate commerce in Annapolis. The idea for the convention had been hatched at Mount Vernon the previous year during a summit regarding access to the Potomac River. Commissioners from Maryland and Virginia had proposed including more states in their ")]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("negotiations. At Annapolis, as Washington would soon learn, talks among delegates from five states had yielded a similar result: a call for another ")]), _c('a', {
    attrs: {
      "id": "note101"
    }
  }, [_vm._v("follow-up meeting, this one to take place in Philadelphia the next year and include even more states. With George Washington presiding, it would be this convention that produced the Constitution. Washington’s beloved Potomac had carried the country on the course to a more perfect union.")])]), _c('a', {
    attrs: {
      "id": "note101"
    }
  }), _c('p', {
    staticClass: "indentb"
  }, [_c('a', {
    attrs: {
      "id": "note101"
    }
  }, [_vm._v("Whether the new document enhancing federal power would become the law of the land would depend on how each state voted at its own convention. Harry Lee championed the cause at Virginia’s convention in 1788. The Constitution, he told his fellow delegates, ")]), _c('a', {
    attrs: {
      "id": "note102"
    }
  }, [_vm._v("“is now submitted to the people of Virginia. If we do not adopt it, it will be always null and void as to us.” Then he explained why fighting beside Washington had convinced him that Virginians should embrace the document.")])]), _c('a', {
    attrs: {
      "id": "note102"
    }
  }), _c('p', {
    staticClass: "blockb"
  }, [_c('a', {
    attrs: {
      "id": "note102"
    }
  }), _c('a', {
    attrs: {
      "id": "note103"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("The people of America, Sir, are one people. I love the people of the North, not because they have adopted the Constitution; but, because I fought with them as my countrymen, and because I consider them as such. Does it follow from hence, that I have forgotten my attachment to my native State? In all local matters I shall be a Virginian: In those of a general nature, I shall not forget that I am an American.")])])]), _c('a', {
    attrs: {
      "id": "note103"
    }
  }), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "note103"
    }
  }, [_vm._v("In the end, the “ayes” barely edged out the “noes.” For the next seven decades, Virginia would submit to the Constitution. Harry next turned his persuasive powers toward recruiting the only conceivable candidate for president. ")]), _c('a', {
    attrs: {
      "id": "note104"
    }
  }, [_vm._v("“Without you,” he told Washington, “the govt can have but little chance of success.”")])]), _c('a', {
    attrs: {
      "id": "note104"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "note104"
    }
  }, [_vm._v("Yet no sooner had Washington sworn to “preserve, protect, and defend the Constitution” than he learned that Harry Lee had changed his opinion about the charter. Harry, according to a report that reached Washington’s desk, was ")]), _c('a', {
    attrs: {
      "id": "note105"
    }
  }, [_vm._v("“one of the number” of Virginians “changing their sentiments, from a conviction of the impracticability of Union with States, whose interests are so dissimilar to those of Virginia.” The ")]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _c('a', {
    attrs: {
      "id": "note106"
    }
  }, [_vm._v("tensions surfaced during the debate over Treasury Secretary Alexander Hamilton’s fiscal reforms, which called for the federal government to assume the debts the states had accumulated during the war. James Madison, among other prominent Virginians, broke with the administration over the policy. His followers would become known as Republicans; Hamilton’s would become known as Federalists. Harry Lee joined Madison in ")]), _c('a', {
    attrs: {
      "id": "note107"
    }
  }, [_vm._v("opposing the assumption scheme but only after trying to profit off insider information. He wanted to know whether the treasury secretary expected securities to rise in value. Hamilton did not indulge ")]), _c('a', {
    attrs: {
      "id": "note108"
    }
  }, [_vm._v("the request, which even Harry conceded might ")]), _c('a', {
    attrs: {
      "id": "note109"
    }
  }, [_vm._v("“be improper.” Whether based on conviction or convenience, Harry’s conversion to antifederalism paid dividends. In 1791, Harry Lee became governor of Virginia.")])]), _c('a', {
    attrs: {
      "id": "note109"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "note109"
    }
  }, [_vm._v("Had Harry remained on the path of Republicanism, his story might have reached a happier ending. But like the prodigal son, he veered back in the other direction and returned to Washington’s camp as a committed Federalist. The ")]), _c('a', {
    attrs: {
      "id": "note110"
    }
  }, [_vm._v("transition was not hard to make. His friendship with the president had remained close even as their politics had drifted apart, and Harry harbored a reflexive dislike for the high priest of Republicanism, Thomas Jefferson. Moreover, a brewing rebellion on the Pennsylvania frontier reminded Harry of the dangers of disunion—the very reason he had supported the Constitution in the first place. The so-called Whiskey Rebellion began in 1794, when westerners revolted against the administration’s excise tax on their favorite drink. With federal authority collapsing along the frontier, Harry shared Washington’s fear that the revolt represented a ")]), _c('a', {
    attrs: {
      "id": "note111"
    }
  }, [_vm._v("“diabolical” plot “to destroy the best fabric of human government and happiness, that has ever been presented for the acceptance of mankind.”")])]), _c('a', {
    attrs: {
      "id": "note111"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "note111"
    }
  }, [_vm._v("Even before the rebellion, Harry had his heart set on restarting his military career. In 1792, Washington had passed him over for command of a western army. To his cabinet, the president had confided that Harry Lee had “more resource” than any other candidate, but, alas, ")]), _c('a', {
    attrs: {
      "id": "note112"
    }
  }, [_vm._v("“no economy.” In desperation, Harry considered going abroad to join the revolutionary struggle in France until Washington convinced him to avoid ")]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("that ")]), _c('a', {
    attrs: {
      "id": "note113"
    }
  }, [_vm._v("“paroxysm of disorder.” So when Washington called out the militia in the summer of 1794, he could not have been surprised to see a letter from his old friend. ")]), _c('a', {
    attrs: {
      "id": "note114"
    }
  }, [_vm._v("“The awful occasion demands united efforts,” Harry wrote. “I beg leave to offer to you my services in any way or station you may deem them proper.” Though Washington himself accompanied the army part of the way west, he entrusted Harry with ")]), _c('a', {
    attrs: {
      "id": "note115"
    }
  }, [_vm._v("command. Facing overwhelming federal force, the revolt quickly fizzled.")])]), _c('a', {
    attrs: {
      "id": "note115"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "note115"
    }
  }, [_vm._v("As opposition to federal authority on the frontier collapsed, opposition to Harry Lee back home mounted. Instead of returning to a hero’s welcome in Virginia, he found himself, as he put it, ")]), _c('a', {
    attrs: {
      "id": "note116"
    }
  }, [_vm._v("“an object of the most virulent enmity.” The now ex-governor was paranoid but not wrong. The politics of Virginia were no longer the politics of Washington. While Harry had realigned himself with the administration, the Old Dominion had swung the other way. Concerns about the growing reach of federal power had shifted loyalties from Washington’s Mount Vernon to Jefferson’s Monticello. And where Virginia had gone, the rest of the country would soon follow. The election of 1800 handed Thomas Jefferson the White House, swept the aging Federalists from power, and all but ended Harry Lee’s public career.")])]), _c('a', {
    attrs: {
      "id": "note116"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "note116"
    }
  }, [_vm._v("Washington did not live to see what became known as the Revolution of 1800. He died a few weeks before the turn of the century. The occasion of his death gave Harry, then serving his one and only term in the House of Representatives, his last and most lasting glory: the honor of delivering Congress’s official eulogy. On December 26 at Philadelphia’s ")]), _c('a', {
    attrs: {
      "id": "note117"
    }
  }, [_vm._v("German Lutheran Church, he uttered the words that would forever connect his name to Washington’s. As Henry “Light-Horse Harry” Lee dismounted the pulpit, he bade farewell to his hero and to any realistic hope for future success.")])]), _c('a', {
    attrs: {
      "id": "note117"
    }
  }, [_c('p', {
    staticClass: "secbreak"
  }, [_vm._v("*  *  *")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "note117"
    }
  }, [_vm._v("Failure after failure followed. Harry compounded the tragedy by dragging down Ann Hill Carter, his second wife. The two had married during his time as governor. Washington had congratulated his friend for having ")]), _c('a', {
    attrs: {
      "id": "note118"
    }
  }, [_vm._v("“exchanged the rugged & dangerous field of Mars, for the ")]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("soft and pleasurable bed of Venus.” Ann’s father, the wealthy Charles Carter, had discouraged the match. His precious ")]), _c('a', {
    attrs: {
      "id": "note119"
    }
  }, [_vm._v("dark-haired daughter deserved better. But her heart was as fixed as the governor’s was fickle. Harry wooed her only after his first choice for a second wife had spurned his advances. Ann warned the other woman, ")]), _c('a', {
    attrs: {
      "id": "note120"
    }
  }, [_vm._v("“Stop, stop . . . you do not know what you are throwing away.” Just twenty years old, Ann soon realized that it was she who had thrown something away: the financial security and comforts that had shielded her childhood. As a relative later told the story, “One fortnight was her dream of happiness from which she awoke to a life of misery.” By the time Charles Carter died in 1806, Harry could no longer afford to send a proper coach to drive Ann home from the funeral. With ")]), _c('a', {
    attrs: {
      "id": "note121"
    }
  }, [_vm._v("no carriage top to shield her from the elements, Ann, then pregnant with what would be her fourth surviving child, rode home to Stratford Hall. Sick and stripped of all illusions, she brought Robert E. Lee into the world on January 19, 1807.")])]), _c('a', {
    attrs: {
      "id": "note121"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "note121"
    }
  }, [_vm._v("Harry did not live with his new child for long. Instead, his debts landed him in ")]), _c('a', {
    attrs: {
      "id": "note122"
    }
  }, [_vm._v("prison. No longer a congressman, no longer a respected voice in the Tidewater, no longer even a free man, Harry’s thoughts returned to the Revolution, that grand stage he had exited too soon. He produced a history of the war’s southern theater. ")]), _c('a', {
    attrs: {
      "id": "note123"
    }
  }, [_vm._v("“Colonel Lee,” a book reviewer noted, “has acquired for himself the reputation of an accurate observer and spirited writer, in addition to that which he had before merited, of a brave soldier.” Leaving prison in 1810, he returned to Stratford. But Henry Lee IV, the oldest surviving son of his late first wife, had reached his ")]), _c('a', {
    attrs: {
      "id": "note124"
    }
  }, [_vm._v("majority, and the great house was now his. The town of Alexandria offered a refuge, and so the Lees packed their belongings and headed upriver. While in prison, Harry had assured his young wife that he would ")]), _c('a', {
    attrs: {
      "id": "note125"
    }
  }, [_vm._v("live out his days by her side, but now she knew better than to bank on her husband’s promises.")])]), _c('a', {
    attrs: {
      "id": "note125"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "note125"
    }
  }, [_vm._v("By 1812, Harry Lee had returned to jail, this time by choice. A sharply split Congress had declared war against Britain. Republicans generally supported the decision; Federalists opposed it. In Baltimore, the streets belonged to the Republicans. When a Federalist newspaper ")]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("in the city editorialized against the war, a mob demanded that the publishers pay for their ink with blood. Two decades earlier, such lawlessness had led Harry back to Washington’s side during the Whiskey Rebellion. Now, for reasons unclear, it led him to Baltimore, where he ")]), _c('a', {
    attrs: {
      "id": "note126"
    }
  }, [_vm._v("holed up in a house with friends of the paper. Outside, the crowd swelled. City officials told the dissidents that their safety required moving to a nearby jail. The publisher protested, but Harry, who by virtue of his military experience had taken command, overrode the objections. On July 28, he led his followers into prison. As darkness descended, the guards defending the jailhouse melted away into the mob. The prison doors were flung open. Harry and his fellow dissidents extinguished the candles. Perhaps they could escape in the confusion. Some succeeded, but Harry Lee was too famous. The mob threw him down the jailhouse steps. Blows rained down on his body. Hands armed with ")]), _c('a', {
    attrs: {
      "id": "note127"
    }
  }, [_vm._v("knives jabbed at his face. As he lay helpless, the assailants dripped hot candle grease into the eyes that once looked up to Washington as a neighbor, as a general, as a president, and as a friend.")])]), _c('a', {
    attrs: {
      "id": "note127"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "note127"
    }
  }, [_vm._v("Somehow Harry returned to Alexandria alive. His vision ")]), _c('a', {
    attrs: {
      "id": "note128"
    }
  }, [_vm._v("slowly recovered, but his scars made him a ")]), _c('a', {
    attrs: {
      "id": "note129"
    }
  }, [_vm._v("sad sight for others to behold. Still in debt and now in chronic pain, he once again longed for a life of obscurity. The clear waters of the Caribbean called. To that end, in the summer of 1813, he ")]), _c('a', {
    attrs: {
      "id": "note130"
    }
  }, [_vm._v("sailed down the river of his ruin, never to see its banks again. The voyage would have given his weary eyes one last glimpse of Mount Vernon resting high above the Potomac. The image was fleeting but not forgotten.")])]), _c('a', {
    attrs: {
      "id": "note130"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c62556b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch01.vue
// module id = 87
// module chunks = 0